import { updateHtmlFromData } from '@/views/website/products/components/description/common/html/update';
import { cloneDeepObject, handleSectionTemplate } from '@/views/website/products/components/description/common/utils';
import { normalizeImgSrc } from '../utils';

export const buildCardSatelliteRivoneed = (baseTemplate, suggestionFields) => {
  const newSection = handleSectionTemplate.insertNewId(cloneDeepObject(baseTemplate));
  if (!newSection?.html) return null;
  const headingContent = suggestionFields.content?.heading;
  const subheadingContent = suggestionFields.content?.subheading;
  const primary_media = suggestionFields.content?.primary_media;
  const typeMedia = primary_media?.media_type;
  const mediaUrl = normalizeImgSrc(primary_media?.url);
  const mediaAlt = primary_media?.alt;
  const feature_grid_items = suggestionFields.content?.feature_grid_items;
  const items = feature_grid_items.map(item => {
    const contentItem = `${item.heading ? `<h3 style='text-align: center;'>${item.heading}</h3>` : ''} ${
      item.body ? `<p style='text-align: center;'>${item.body}</p>` : ''
    }`;
    const imageSrc = normalizeImgSrc(item.media?.url || '');
    const imageAlt = item.media?.alt || '';
    return {
      content: contentItem,
      imageSrc,
      imageAlt,
    };
  });
  const imgFallback = 'https://cdn.skyfastimg.com/images/2026/07/20/image-6a5ddda9d221c26bbb0d389a.png';
  const fieldUpdate = {
    cardTitle: {
      show: headingContent || subheadingContent,
      content: `${headingContent ? `<h2 style='text-align: center;'>${headingContent}</h2>` : ''} ${
        subheadingContent ? `<p style='text-align: center;'>${subheadingContent}</p>` : ''
      }`,
    },
    mainMedia: {
      type: primary_media ? typeMedia : 'image',
      videoSrc: typeMedia === 'video' && primary_media ? mediaUrl : '',
      imageSrc: typeMedia === 'image' && primary_media ? mediaUrl : imgFallback,
      imageAlt: mediaAlt,
    },
    items,
  };

  return {
    ...newSection,
    html: updateHtmlFromData.sectionCardSatelliteRivoneed(newSection.html, fieldUpdate),
  };
};
export const buildTinoGridSection = (baseTemplate, suggestionFields) => {
  const newSection = handleSectionTemplate.insertNewId(cloneDeepObject(baseTemplate));
  if (!newSection?.html) return null;
  const headingContent = suggestionFields.content?.heading;
  const feature_grid_items = suggestionFields.content?.feature_grid_items;

  const items = feature_grid_items.map(item => {
    const imageSrc = normalizeImgSrc(item.media?.url || '');
    const textBody = item.body.replace(/<a\b[^>]*>(.*?)<\/a>/g, '$1');
    return {
      image: imageSrc,
      itemBackground: '#f3f3f3',
      itemTextColor: '#000000',
      showText: true,
      content: `${item.heading ? `<h3>${item.heading}</h3>` : ''} ${item.body ? `<p>${textBody}</p>` : ''}`,
    };
  });

  const fieldUpdate = {
    'title-section': headingContent,
    backgroundColor: '#ffffff',
    itemBackground: '#f3f3f3',
    listItem: items,
  };

  return {
    ...newSection,
    html: updateHtmlFromData.sectionTinoGrid(newSection.html, fieldUpdate),
  };
};
